import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileUpload } from "@/components/FileUpload";

interface DecryptSectionProps {
  onBack: () => void;
}

const DecryptSection = ({ onBack }: DecryptSectionProps) => {
  return (
    <div className="space-y-4">
      <Button variant="outline" onClick={onBack}>
        Back to Options
      </Button>
      <Card>
        <CardHeader>
          <CardTitle>Decrypt Files</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground mb-4">
            Upload an encrypted file to decrypt it
          </p>
          <FileUpload buttonText="Decrypt File" />
        </CardContent>
      </Card>
    </div>
  );
};

export default DecryptSection;